<template>
  <vs-popup :active.sync="open"
            :buttons-hidden="true"
            @close="open = false"
            class="assign-formulation-stock-inventory-pop-up"
            title="CREATE SUNDRY ITEM INVENTORY">
    <vx-card no-shadow >
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-rm-stock-inventory" @submit.prevent="handleSubmit(onClickAssign)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="company_product_code" name="company_product_code" rules="required" v-slot="{ errors }">
                <small class="label">Sundry Item Code</small>
                <vs-input disabled :value="rm_item.sundry_item_code"   name="company_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="total_quantity" name="total_quantity" rules="required" v-slot="{ errors }">
                <small class="label">Total Quantity (Kg)</small>
                <vs-input type="number" step="0.1" v-model="form.total_quantity"   name="company_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

           <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_batch_no" name="supplier_batch_no" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Batch Number</small>
                <vs-input v-model="form.supplier_batch_no"   name="supplier_batch_no" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="location" name="location" rules="required" v-slot="{ errors }">
                <small class="label">Shelf Location</small>
                <vs-input v-model="form.location"   name="location" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      id: '',
      shelf_location_r_options: [],
      shelf_location_s_options: [],
      shelf_location_l_options: [],
      form: {
        manufacture_date: '',
        expiration_date: '',
        batch_no: '',
        company_product_code: '',
        category: '',
        total_quantity: '',
        supplier_batch_no: '',
      },
      rm_item: {},
      qc_test_id: ''
    }
  }

  export default {
    name: 'AssignFormulationStockPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(rm_item, qc_test_id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.rm_item = rm_item;
          this.qc_test_id = qc_test_id
          this.form.total_quantity = rm_item.quantity
          this.open = true;
        } catch (error) {

        }
      },
      async closePopup() {
        this.open = false;
      },
      async onClickAssign() {
        const vue = this
        await this.$vs.loading({
          container: '#create-rm-stock-inventory',
          scale: 0.45
        })
        try {
          const payload = {
            sundry_item_order_item_id: this.rm_item.id,
            sundry_item_id: this.rm_item.sundry_item_id,
            total_quantity: this.form.total_quantity,
            location: this.form.location,
            sundry_order_item_q_c_test_id: this.qc_test_id,
            supplier_batch_no: this.form.supplier_batch_no
          }
          await ManufacturingRepository.createSundryItemInventory(payload)
          this.showSuccessMessage('Sundry Item Stock Inventory created!')
          await this.closePopup()
          await vue.$parent.refreshData()
          this.$vs.loading.close('#create-rm-stock-inventory > .con-vs-loading')
        } catch (e) {
          this.showErrorMessage(e)
          this.$vs.loading.close('#create-rm-stock-inventory > .con-vs-loading')
        }

      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .assign-formulation-stock-inventory-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }

</style>
